import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Tracker } from "@/components/Tracker";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { Protected } from "@/components/Protected";
import { AuthCallback } from "@/components/AuthCallback";
import Contact from "@/pages/Contact";
import { Account, ForgotPassword, ResetPassword } from "@/pages/AuthPages";
import Documents, { CreditAuthForm } from "@/pages/Documents";
import Landing from "@/pages/Landing";
import Store from "@/pages/Store";
import Apply from "@/pages/Apply";
import Login from "@/pages/Login";
import PartnerPortal from "@/pages/PartnerPortal";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";

function Shell() {
  const { pathname, hash } = useLocation();
  const bare = ["/login", "/forgot-password", "/reset-password", "/credit-authorization-form"].includes(pathname);
  if (hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <SmoothScroll />
      <Tracker />
      <Nav />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/store" element={<Store />} />
        <Route path="/apply" element={<Apply />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/credit-authorization-form" element={<CreditAuthForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/account" element={<Protected><Account /></Protected>} />
        <Route path="/portal" element={<Protected><PartnerPortal /></Protected>} />
        <Route path="/admin" element={<Protected role="admin"><Admin /></Protected>} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      {!bare && <Footer />}
      <CartDrawer />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
